import React, { FC } from 'react';
import {
    SkeletonBlock,
    SkeletonCanvasBlock,
    SkeletonFlexSpacer,
    SkeletonFullscreenContent,
    SkeletonFullscreenOverlay,
    SkeletonFullscreenTopBar
} from 'src/components/widgets/skeleton';

export const TestPageSkeleton: FC = () => (
    <SkeletonFullscreenOverlay aria-hidden='true'>
        <SkeletonFullscreenTopBar>
            <SkeletonBlock $width='36px' $height='36px' $round />
            <SkeletonBlock $width='180px' $height='22px' $radius='8px' />
            <SkeletonBlock $width='150px' $height='32px' $radius='8px' />
            <SkeletonFlexSpacer />
            <SkeletonBlock $width='100px' $height='32px' $radius='8px' />
            <SkeletonBlock $width='36px' $height='36px' $round />
        </SkeletonFullscreenTopBar>
        <SkeletonFullscreenContent>
            <SkeletonCanvasBlock $width='60%' $height='70%' $radius='8px' />
        </SkeletonFullscreenContent>
    </SkeletonFullscreenOverlay>
);
